import "./BrandbarAccountInformation.scss";

import React from "react";

import { FormattedMessage } from "react-intl";
import { Dropdown, Row, Col } from "react-bootstrap";
import { connect } from "shared/src/stores/storeConnect";
import { DisplayName } from "../../DisplayName";
import { Link } from "../../../../datatypes/ConfiguredLinks";
import { BrandbarPopoverContent } from "./BrandbarPopoverContent";
import { BusinessAccountAbbreviationCircle } from "../businessaccounts/BusinessAccountAbbreviationCircle";
import { BusinessAccountResponse } from "../../../../datatypes/businessaccounts/BusinessAccount";
import { BusinessAccountStore } from "../../../../stores/businessaccounts/BusinessAccountStore";
import LoginRegistrationGroup from "../LoginRegistrationGroup";
import { AnimationDropdownMenu } from "../../AnimationDropdownMenu";
import { BusinessAccount } from "../../../../datatypes/businessaccounts/BusinessAccount";
import { LogoutLink } from "../businessaccounts/LogoutLink";
import CustomerStore from "../../../../stores/CustomerStore";
import Customer, { extractCardholder } from "shared/src/types/customer/Customer";
import SessionStore, { isTier12Customer } from "shared/src/stores/SessionStore";
import { History } from "history";

type Props = {
    customer: Customer | undefined | null;
    country: string;
    cardholderNumber: string | null | undefined;
    links: Array<Link>;
    businessAccountData: BusinessAccountResponse | undefined | null;
    isMetroX?: boolean;
    isLoggedIn?: boolean;
    isEmployee?: boolean;
    isTier12Customer?: boolean;
    className?: string;
    history?: History;
};

type State = {
    accountDropdownPage: number;
    clientHeight: number;
    isMenuVisible: boolean;
};

class BrandbarAccountInformation extends React.Component<Props, State> {
    brandbarPopoverContent: React.RefObject<BrandbarPopoverContent>;

    constructor(props: Props) {
        super(props);
        this.state = { accountDropdownPage: 1, clientHeight: 0, isMenuVisible: false };
        this.brandbarPopoverContent = React.createRef();
    }

    isBusinessAccount() {
        return !!this.props.businessAccountData;
    }

    getActiveAccount(): BusinessAccount | undefined | null {
        if (!this.props.businessAccountData) {
            return null;
        }
        const activeAccountId = this.props.businessAccountData?.activeAccountId;
        return this.props.businessAccountData?.accountData?.find((account) => activeAccountId === account.id);
    }

    setAccountDropDownPage = (page: number) => {
        this.setState({ accountDropdownPage: page });
    };

    setClientHeight = (height: number) => {
        if (height > this.state.clientHeight) {
            this.setState({ clientHeight: height });
        }
    };

    renderAccountIcon(
        isBusinessAccount: boolean,
        loggedInPersonName: React.ReactNode,
        businessName: string | undefined,
        activeBusinessAccount: BusinessAccount | undefined | null
    ) {
        return (
            <div className="brandbar-account-toggle test-account-icon">
                {this.props.isMetroX && (
                    <div className="hidden-md hidden-lg hidden-xl">
                        <p className="brandbar-account-customer-name-mobile">{loggedInPersonName}</p>
                    </div>
                )}
                {!isBusinessAccount && (
                    <img
                        src={"/ordercapture/uidispatcher/static/app/assets/images/metroXHeaderAccountIcon.svg"}
                        alt={this.context?.intl?.formatMessage({
                            id: "CA_BRANDBAR_MOBILE_GREETING"
                        })}
                        className="brandbar-profile-icon"
                    />
                )}
                <div className="hidden-sm hidden-xs">
                    <p className="brandbar-account-customer-name test-first-line">{loggedInPersonName}</p>
                    <p className="brandbar-account-second-line test-second-line">{businessName}</p>
                </div>
                {isBusinessAccount && (
                    <BusinessAccountAbbreviationCircle businessAccount={activeBusinessAccount} smallVersion />
                )}
            </div>
        );
    }

    render() {
        if (this.props.customer) {
            const customer = this.props.customer;
            const isBusinessAccount = this.isBusinessAccount();
            const activeBusinessAccount = this.getActiveAccount();
            let loggedInPersonName: React.ReactNode = isBusinessAccount
                ? this.props.businessAccountData?.person?.name
                : customer.commercialName;
            const businessName = isBusinessAccount ? activeBusinessAccount?.corporateName : customer.customerName;
            //default maybe cardholder name?
            if (!loggedInPersonName) {
                const cardholderNumber = this.props.cardholderNumber;
                loggedInPersonName = (
                    <DisplayName
                        customer={customer && cardholderNumber ? extractCardholder(customer, cardholderNumber) : null}
                        displayMiddleName={false}
                    />
                );
            }
            const nonBusinessAccountsClassName = isBusinessAccount ? "" : " default-ca-account";
            const isMetroXClassName = this.props.isMetroX ? " is-metro-x hidden-sm" : "";
            return (
                <div className="mfcss">
                    <div className="m">
                        <div
                            className={
                                "brandbar-account brandbar-account-slide-animation hidden-xs" +
                                nonBusinessAccountsClassName +
                                isMetroXClassName
                            }>
                            <Dropdown id="dd01" pullRight>
                                <Dropdown.Toggle onClick={() => this?.brandbarPopoverContent?.current?.setHeight()}>
                                    {this.renderAccountIcon(
                                        isBusinessAccount,
                                        loggedInPersonName,
                                        businessName,
                                        activeBusinessAccount
                                    )}
                                </Dropdown.Toggle>
                                <div className="dropdown-menu-arrow" />
                                <Dropdown.Menu className="dropdown-with-arrow" id={"dropdownMenuSetHeight"}>
                                    <AnimationDropdownMenu
                                        transitionName={
                                            this.state.accountDropdownPage === 1
                                                ? "animation-dropdown-slide-right"
                                                : "animation-dropdown-slide-left"
                                        }>
                                        <div
                                            className="dropdown-menu-item-animation-container"
                                            key={"accountDropdownPage" + this.state.accountDropdownPage}>
                                            <BrandbarPopoverContent
                                                ref={this.brandbarPopoverContent}
                                                businessAccountData={this.props.businessAccountData}
                                                activeBusinessAccount={activeBusinessAccount}
                                                name={loggedInPersonName}
                                                businessName={businessName}
                                                contentToDisplay={this.state.accountDropdownPage}
                                                setAccountDropDownPage={this.setAccountDropDownPage}
                                                setClientHeight={this.setClientHeight}
                                                clientHeight={this.state.clientHeight}
                                                history={this.props.history}
                                            />
                                        </div>
                                    </AnimationDropdownMenu>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        {this.props.isMetroX && (
                            <div className={"dropdown brandbar-account-mobile hidden-md hidden-lg hidden-xl"}>
                                <div
                                    className="test-open-flyout"
                                    onClick={() => {
                                        this.setState({ isMenuVisible: !this.state.isMenuVisible });
                                        window.document.body.classList.add("disable-scrolling");
                                    }}>
                                    {this.renderAccountIcon(
                                        isBusinessAccount,
                                        loggedInPersonName,
                                        businessName,
                                        activeBusinessAccount
                                    )}
                                </div>
                                <ul className="dropdown-menu hide-in-background">
                                    <AnimationDropdownMenu transitionName="animation-slideFromRight">
                                        {this.state.isMenuVisible && (
                                            <div className={"flyout-menu-item-animation-container test-metro-x-flyout"}>
                                                <Row className="flyout-greeting">
                                                    <Col xs={1}>
                                                        <img
                                                            src={
                                                                "/ordercapture/uidispatcher/static/app/assets/images/metroXHeaderAccountIcon.svg"
                                                            }
                                                            alt={this.context?.intl?.formatMessage({
                                                                id: "CA_BRANDBAR_MOBILE_GREETING"
                                                            })}
                                                            className="brandbar-profile-icon"
                                                        />
                                                    </Col>
                                                    <Col xs={9}>
                                                        <div className="brandbar-greeting-text">
                                                            <FormattedMessage id={"CA_BRANDBAR_MOBILE_GREETING"} />{" "}
                                                            {loggedInPersonName}
                                                        </div>
                                                    </Col>
                                                    <Col xs={2}>
                                                        <div
                                                            className="brandbar-close test-close-flyout"
                                                            onClick={() => {
                                                                this.setState({
                                                                    isMenuVisible: !this.state.isMenuVisible
                                                                });
                                                                window.document.body.classList.remove(
                                                                    "disable-scrolling"
                                                                );
                                                            }}>
                                                            <i className="icon-big-mobile-close icon-2x" />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <BrandbarPopoverContent
                                                    businessAccountData={this.props.businessAccountData}
                                                    activeBusinessAccount={activeBusinessAccount}
                                                    name={loggedInPersonName}
                                                    businessName={businessName}
                                                    contentToDisplay={this.state.accountDropdownPage}
                                                    setAccountDropDownPage={this.setAccountDropDownPage}
                                                    setClientHeight={this.setClientHeight}
                                                    clientHeight={this.state.clientHeight}
                                                    history={this.props.history}
                                                />
                                            </div>
                                        )}
                                    </AnimationDropdownMenu>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            );
        } else if (
            this.props.isMetroX &&
            this.props.isTier12Customer &&
            this.props.isLoggedIn &&
            !this.props.isEmployee
        ) {
            return (
                <div className="brandbar-account logout-button">
                    <LogoutLink data={null} />;
                </div>
            );
        } else {
            return <LoginRegistrationGroup isMetroX={this.props.isMetroX} />;
        }
    }
}

export default connect(
    {
        stores: [
            [
                CustomerStore,
                (store: typeof CustomerStore) => ({
                    customer: store.getCustomer()
                })
            ],
            [
                BusinessAccountStore,
                (store: typeof BusinessAccountStore) => {
                    const businessAccountData = store.getData();
                    return { businessAccountData };
                }
            ],
            [
                SessionStore,
                (store: typeof SessionStore) => ({
                    isEmployee: store.getState().isEmployee,
                    isLoggedIn: store.getState().loggedIn,
                    country: store.getState().country,
                    cardholderNumber: store.getState().cardholderNumber,
                    isTier12Customer: isTier12Customer()
                })
            ]
        ]
    },
    BrandbarAccountInformation
);
